import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountLocatorPart  {
    _originalTypeClassName = "zERP.BO.AccountLocatorPart";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountLocatorPart.translate = translateService;
}
this.AccountSelectionConditions = [];
this.Conditions = [];
this.Accounts = [];
this.Id = null;
this.Type = null;
this.Value = null;
this.DynamicOptionLevel = null;
this.AccountLevel = null;
this.Level = null;
this.HonorAccountingCategories = false;
this.ExpressionSubstring = false;
this.ExpressionStartIndex = null;
this.ExpressionLength = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Type:any;
Value:any;
DynamicOptionLevel:any;
AccountLevel:any;
Level:any;
HonorAccountingCategories:any;
ExpressionSubstring:any;
ExpressionStartIndex:any;
ExpressionLength:any;
AccountSelectionConditions:any;
Conditions:any;
Accounts:any;
AccountFiltering:any;
static setAccountSelectionConditions = ($this, items) => {
                if (items == null) items = [];
                if ($this.AccountSelectionConditions == null) $this.AccountSelectionConditions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.AccountSelectionConditions.length > 0) {
                    Domain.AccountLocatorPart.removeAccountSelectionConditions($this, $this.AccountSelectionConditions[0]);
                }

                Domain.AccountLocatorPart.addManyAccountSelectionConditions($this, copyItems);
            }
static addManyAccountSelectionConditions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorPart.addAccountSelectionConditions($this, items[i]);
                }
            }
static addAccountSelectionConditions = ($this, item) => {
                if ($this.AccountSelectionConditions == null) $this.AccountSelectionConditions = [];
                if (item == null || $this.AccountSelectionConditions.indexOf(item) > -1) return;
                $this.AccountSelectionConditions.push(item);
}
static addRangeAccountSelectionConditions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorPart.addAccountSelectionConditions($this, item));
            }
static removeAccountSelectionConditions = ($this, item) => {
                if ($this == null || $this.AccountSelectionConditions == null || $this.AccountSelectionConditions.indexOf(item) === -1) return;
                var _index = $this.AccountSelectionConditions.indexOf(item);
                $this.AccountSelectionConditions.splice(_index, 1);
}
static clearAccountSelectionConditions = ($this) => { $this.AccountSelectionConditions = null; }
static setConditions = ($this, items) => {
                if (items == null) items = [];
                if ($this.Conditions == null) $this.Conditions = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Conditions.length > 0) {
                    Domain.AccountLocatorPart.removeConditions($this, $this.Conditions[0]);
                }

                Domain.AccountLocatorPart.addManyConditions($this, copyItems);
            }
static addManyConditions = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorPart.addConditions($this, items[i]);
                }
            }
static addConditions = ($this, item) => {
                if ($this.Conditions == null) $this.Conditions = [];
                if (item == null || $this.Conditions.indexOf(item) > -1) return;
                $this.Conditions.push(item);
}
static addRangeConditions = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorPart.addConditions($this, item));
            }
static removeConditions = ($this, item) => {
                if ($this == null || $this.Conditions == null || $this.Conditions.indexOf(item) === -1) return;
                var _index = $this.Conditions.indexOf(item);
                $this.Conditions.splice(_index, 1);
}
static clearConditions = ($this) => { $this.Conditions = null; }
static setAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Accounts == null) $this.Accounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Accounts.length > 0) {
                    Domain.AccountLocatorPart.removeAccounts($this, $this.Accounts[0]);
                }

                Domain.AccountLocatorPart.addManyAccounts($this, copyItems);
            }
static addManyAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountLocatorPart.addAccounts($this, items[i]);
                }
            }
static addAccounts = ($this, item) => {
                if ($this.Accounts == null) $this.Accounts = [];
                if (item == null || $this.Accounts.indexOf(item) > -1) return;
                $this.Accounts.push(item);
}
static addRangeAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountLocatorPart.addAccounts($this, item));
            }
static removeAccounts = ($this, item) => {
                if ($this == null || $this.Accounts == null || $this.Accounts.indexOf(item) === -1) return;
                var _index = $this.Accounts.indexOf(item);
                $this.Accounts.splice(_index, 1);
}
static clearAccounts = ($this) => { $this.Accounts = null; }
static setAccountFiltering = ($this, value) => {
var oldValue = $this.AccountFiltering;
$this.AccountFiltering = value;
if (value != null) {
}
}

static UpdateAccountConditions($this: any): any{if ($this?.Type != Domain.AccountLocatorType.SpecificAccount) {$this?.AccountSelectionConditions?.splice(0, $this?.AccountSelectionConditions.length);return;}
for (let _iselectedAccount = 0; _iselectedAccount < ($this?.Accounts == null ? 0 : $this?.Accounts.length); _iselectedAccount++) {let selectedAccount = $this?.Accounts[_iselectedAccount];let existing = $this?.AccountSelectionConditions?.linq?.where((a) => a?.AccountCode == selectedAccount?.Code)?.firstOrDefault(null);if (existing != null) {continue;}let item = new Domain.AccountLocatorPartSelectionCondition();item.AccountCode = selectedAccount?.Code;$this?.AccountSelectionConditions?.add(existing);}
let itemsToRemove = [];
for (let _iold = 0; _iold < ($this?.AccountSelectionConditions == null ? 0 : $this?.AccountSelectionConditions.length); _iold++) {let old = $this?.AccountSelectionConditions[_iold];let existing = $this?.Accounts?.linq?.where((a) => a?.Code == old?.AccountCode)?.firstOrDefault(null);if (existing != null) {continue;}itemsToRemove?.add(old);}
while ((itemsToRemove?.linq?.any())) {let toRemove = itemsToRemove?.linq?.where()?.firstOrDefault(null);itemsToRemove?.splice(itemsToRemove.indexOf(toRemove), 1);$this?.AccountSelectionConditions?.splice($this?.AccountSelectionConditions.indexOf(toRemove), 1);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}